enum Apps {
  HKSTP608 = 'hkstp608',
  Jetro817 = 'jetro817',
  Lighthouse710 = 'lighthouse710',
  Ms624 = 'ms624',
  Neoventure1012 = 'neoventure1012',
  Paloalto623 = 'paloalto623',
  PicoX707 = 'picox707',
  PolyU618 = 'polyu618',
  Reed902 = 'reed902',
  SCMP711 = 'scmp711',
  SPH706 = 'sph706',
  Uzabase826 = 'uzabase826',
  VirtualDemo = 'xtra',
  VirtualPressCon = 'xtrapresscon',
  XtraCMS = 'xtracms',
}

export default Apps;
